const prjtaskActionTypes = {
  SET_PRJTASKS: "SET_PRJTASKS",
};

export default prjtaskActionTypes;
